import { SelectableOption } from '@/components/ui/selectable-option';
import type { QuestionGroup } from './survey-model';

/**
 * Um passo de perguntas: grupos de opções marcáveis, uma lista por grupo.
 *
 * Os três passos longos do questionário — observação básica, comportamento
 * infantil e exame do estado mental — têm exatamente esta forma; só mudam os
 * grupos e o trecho da resposta que eles preenchem.
 */
export default function SurveyQuestionGroups<TField extends string>({
    groups,
    values,
    onToggle,
}: {
    groups: QuestionGroup<TField>[];
    values: Partial<Record<TField, string[]>>;
    onToggle: (field: TField, option: string) => void;
}) {
    return (
        <>
            {groups.map((group) => {
                const selected = values[group.id] || [];

                return (
                    <div key={group.id} className="space-y-3">
                        <h4 className="text-sm font-semibold text-foreground">{group.title}</h4>
                        <div className="space-y-2">
                            {group.options.map((option) => (
                                <SelectableOption
                                    key={option}
                                    control="checkbox"
                                    checked={selected.includes(option)}
                                    onToggle={() => onToggle(group.id, option)}
                                    label={option}
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </>
    );
}
